import React from 'react';
import { DatasetLicenses } from './types';

const ManageMetadataComponentContext = React.createContext<{
  datasetLicenses: DatasetLicenses;
}>({ datasetLicenses: [] });
ManageMetadataComponentContext.displayName = 'Manage metadata component context';

export default ManageMetadataComponentContext;
